import * as React from 'react';

import store from '../pages/store';
import { createReactRenderer } from 'helpers/react-renderer';
import { HubLabelPrintModal } from 'label/HubPrint';

import LabelPrintModal from './LabelPrintModal';

interface Props {
  labelApiUrl: string;
}

export const renderZbpLabelPrintModal = (labelApiUrl: string) => {
  renderModal(labelApiUrl, LabelPrintModal as unknown as React.ComponentClass<Props>);
};

export const renderHubLabelPrintModal = (labelApiUrl: string) => {
  renderModal(labelApiUrl, HubLabelPrintModal);
};

const renderModal = <T extends React.ComponentType<Props>>(labelApiUrl: string, component: T) => {
  const RenderedComponent = createReactRenderer({
    component,
    props: {
      labelApiUrl,
    },
    selector: '[data-react-root="ReactModal"]',
    store,
  });

  RenderedComponent.mount();
};
